import axios from '../utils/axios';

export default function captchaVerification(adminId, data) {
    return axios.post(`/admin/${adminId}/captcha-token-validator`, data);

};